import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

export const getNumberOfNestedChildrenInSection = (
  item: DocumentItem<SectionItemAttributes>,
) =>
  (item?.children || []).reduce(
    (acc, childrenCollection) =>
      acc + (childrenCollection?.children?.length || 0),
    0,
  );
